import types from './types';
import create from '~/misc/create';
import {push as changeURL} from 'react-router-redux';

import get from 'lodash/get';
import HTTPError from '~/misc/HTTPError';
import {
  promiseAction,
  ActionError,
} from '~/misc/dispatch';
import * as api from './api';

export const createOrderActions = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.CUSTOMER_SERVICE_CREATE_ORDER,
  api.createOrderApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
).then((res) => {
  dispatch(changeURL(
    `/create-pending-payment?ID=${val.ID}&firstName=${val.firstName}&lastName=${val.lastName}&business_code=${res.data.business_code}&order_id=${res.data.order_id}`));
});

export const getDirectOrderInfo = (dispatch, getState, ID) => promiseAction(
  dispatch,
  getState,
  types.GET_DIRECT_ORDER_INFO,
  api.getDirectOrderInfoApi(getState, ID).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);

export const getPaymentInfo = (dispatch, getState, orderId) => promiseAction(
  dispatch,
  getState,
  types.GET_DIRECT_ORDER_PAYMENT_INFO,
  api.getPaymentInfoApi(getState, orderId).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
);

export const createPayOrderAction = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.CREATE_PAY_ORDER,
  api.createAccountPayOrderApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
);



// WEBPACK FOOTER //
// ./src/modules/customerServicePaymentProcess/actions.js